<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

interface SemboBenefitsModalEmits {
  (event: 'close-modal'): void;
}
const emit = defineEmits<SemboBenefitsModalEmits>();
</script>

<template>
  <AppStandardModal
    is-button-disabled
    overflow="visible"
    @close="emit('close-modal')"
  >
    <template #title>
      {{ $t('sembo_benefits.title') }}
    </template>
    <template #body>
      <div class="benefit">
        <span class="benefit-title">
          {{ $t('sembo_benefits.value_section.title') }}
        </span>
        <span class="benefit-description">
          {{ $t('sembo_benefits.value_section.content') }}
        </span>
      </div>
      <div class="benefit">
        <span class="benefit-title">
          {{ $t('sembo_benefits.trust_section.title') }}
        </span>
        <span class="benefit-description">
          {{ $t('sembo_benefits.trust_section.content') }}
        </span>
      </div>
      <div class="benefit">
        <span class="benefit-title">
          {{ $t('sembo_benefits.simplicity_section.title') }}
        </span>
        <span class="benefit-description">
          {{ $t('sembo_benefits.simplicity_section.content') }}
        </span>
      </div>
      <div class="benefit">
        <span class="benefit-title">
          {{ $t('sembo_benefits.freedom_section.title') }}
        </span>
        <span class="benefit-description">
          {{ $t('sembo_benefits.freedom_section.content') }}
        </span>
      </div>
    </template>
  </AppStandardModal>
</template>

<style scoped lang="scss">
.benefit {
  margin-bottom: var(--spacing-32);
  display: flex;
  flex-direction: column;
  .benefit-title {
    @include font-body-l-bold;
  }
  .benefit-description {
    @include font-body-l-light;
  }
}
</style>
